import { TFile } from "../base";
import { z } from "zod";
import { TFirebaseTimestampToISO } from "../deprecated";
import { TTranslationData } from "./translation";
import { TApiCustomField } from "../customFields/customFields";

//TODO: refactor these names to new format without api
// IApiCollectionItemMetadata -> IMetadataCollectionItem
// Showing that this is the format for collection items if added to the metadata

export type IApiCollectionItemMetadata = z.infer<
  typeof TApiCollectionItemMetadata
>;
export const TApiCollectionItemMetadata = z.object({
  id: z.string(),
  name: z.string(),
});

export type IApiCollectionMetadata = z.infer<typeof TApiCollectionMetadata>;
export const TApiCollectionMetadata = z.object({
  id: z.string(),
  name: z.any(),
  type: z.number().optional(),
});

export type IApiCompanyMetadata = z.infer<typeof TApiCompanyMetadata>;
export const TApiCompanyMetadata = z.object({
  id: z.string(),
  name: z.string().optional(),
});

export type IApiCompanyTagMetadata = z.infer<typeof TApiCompanyTagMetadata>;
export const TApiCompanyTagMetadata = z.object({
  id: z.string(),
  badgeColor: z.string().optional(),
  badgeIcon: z.string().optional(),
  name: TTranslationData,
});

export type IApiCompanyTaskTypeMetadata = z.infer<
  typeof TApiCompanyTaskTypeMetadata
>;
export const TApiCompanyTaskTypeMetadata = z.object({
  id: z.string(),
  title: TTranslationData,
  customFields: z.array(TApiCustomField).optional(),
  requiredFields: z.array(z.string()).optional(),
  description: z.string().optional(),
  color: z.string().optional(),
});

export type IApiContractorGroupMetadata = z.infer<
  typeof TApiContractorGroupMetadata
>;
export const TApiContractorGroupMetadata = z.object({
  id: z.string(),
  name: z.string().optional(),
});

const TUserProfilePictureMetadata = z.object({
  large: TFile.optional(),
  small: TFile.optional(),
});

export type IApiInvoiceReceiverMetadata = z.infer<
  typeof TApiInvoiceReceiverMetadata
>;
export const TApiInvoiceReceiverMetadata = z.object({
  id: z.string().optional(),
  address: z.string().optional(),
  email: z.string().optional(),
  orgNumber: z.string().optional(),
  postBox: z.string().optional(),
  postalCode: z.string().optional(),
  reference: z.string().optional(),
  receiver: z.string().optional(),
});

export type IApiRoutineMetadata = z.infer<typeof TApiRoutineMetadata>;
export const TApiRoutineMetadata = z.object({
  id: z.string(),
  title: z.any(),
  startDate: TFirebaseTimestampToISO.optional(),
});

export type IApiExternalLinkMetadata = z.infer<typeof TApiExternalLinkMetadata>;
export const TApiExternalLinkMetadata = z.object({
  id: z.string(),
  active: z.boolean().optional(),
  title: z.string().optional(),
  canCreateTasks: z.boolean().optional(),
  canSendComment: z.boolean().optional(),
  canUpdateStatus: z.boolean().optional(),
  tasks: z
    .object({
      all: z.boolean().optional(), // `all` is optional and can be a boolean or undefined
    })
    .optional(),
  openCount: z.number().optional(),
  tokenID: z.string().optional(),
  url: z.string().optional(),
  createdBy: z.any().optional(),
  updatedBy: z.any().optional(),
});

export type IApiTaskMetadata = z.infer<typeof TApiTaskMetadata>;
export const TApiTaskMetadata = z.object({
  id: z.string(),
  title: z.string(),
});

export type IApiUserMetadata = z.infer<typeof TApiUserMetadata>;
export const TApiUserMetadata = z.object({
  id: z.string(),
  name: z.string().optional(),
  profileImages: TUserProfilePictureMetadata.optional(),
});

export type IApiPropertyMetadata = z.infer<typeof TApiPropertyMetadata>;
export const TApiPropertyMetadata = z.object({
  id: z.string(),
  name: z.string().optional(),
  headerImage: TFile.optional(),
});

export type IApiTaskDetailRelativeMetadata = z.infer<
  typeof TApiTaskDetailRelativeMetadata
>;
export const TApiTaskDetailRelativeMetadata = z.object({
  id: z.string(),
  name: z.string().optional(),
  title: z.string().optional(),
  startDate: z.string().optional(),
});

export type IApiUnitMetadata = z.infer<typeof TApiUnitMetadata>;
export const TApiUnitMetadata = z.object({
  id: z.string(),
  name: z.string(),
});

export const TApiUnitsMetadata = z.array(TApiUnitMetadata);
export type IApiUnitsMetadata = z.infer<typeof TApiUnitsMetadata>;

/**
 * @deprecated use TTask instead
 */
export type IApiTaskMetadataObject = z.infer<typeof TApiTaskMetadataObject>;
/**
 * @deprecated use TTask instead
 */
export const TApiTaskMetadataObject = z.object({
  contractorGroups: z.array(TApiContractorGroupMetadata).optional(),
  executors: z.array(TApiUserMetadata).optional(),
  responsibles: z.array(TApiUserMetadata).optional(),
  property: TApiPropertyMetadata.optional(),
  invoiceReceiver: TApiInvoiceReceiverMetadata.optional(),
});

/**
 * @deprecated use TTask instead
 */
export type IApiTaskDetailMetadataObject = z.infer<
  typeof TApiTaskDetailMetadataObject
>;
/**
 * @deprecated use TTask instead
 */
export const TApiTaskDetailMetadataObject = TApiTaskMetadataObject.extend({
  companyNames: z.array(TApiCompanyMetadata).optional(),
  user: TApiUserMetadata.optional(),
  units: z.array(TApiUnitMetadata).optional(),
  routine: TApiRoutineMetadata.optional(),
  relatives: z.array(TApiTaskDetailRelativeMetadata).optional(),
  tags: z.array(TApiCompanyTagMetadata).optional(),
  taskType: TApiCompanyTaskTypeMetadata.optional(),
  externalLinks: z.array(TApiExternalLinkMetadata).optional(),
});
